module.exports = __webpack_public_path__ + "img/WebexToken_3.5ccb43fd.png";